<template>
	<div
		class="plp-wrapper m-0"
		:class="((getFilterCount < 1 || noProductsConditionCheck) &&
        !isFilterApplied) ? 'col-lg-12 col-xl-12': 'col-lg-9 col-xl-10'"
	>
		<div
			class="row m-0"
			v-if="hideSort"
		>
			<product-listing-top-panel
				:productsLength="getSelectedProduct.length"
				:activeCategory="activeCategory"
				v-if="!($route.path === '/promotional_product-list' ||
				$route.path === '/recommend-products' ||
                                $route.path === '/search-results' &&
                                $route.query.is_a_category === false)"
			/>
		</div>
		<div class="row">
			<product-list-template
				v-for="(product,key) in productsData"
				:key="key"
				:product=product
				:position="parseInt(key)"
			/>
			<div
				class="cd-fail-message"
				v-if="(productList && productList.length <= 0 && isFilterApplied)"
				id="filter-no-pdt-found-filter"
				data-test="productListSectionNoFilter"
			>
				No Products Found for Current Filter Combinations
			</div>
			<div
				class="cd-fail-message"
				v-else-if=noProductsConditionCheck
				id="filter-no-pdt-found"
				data-test="productListSectionNoPdts"
			>
				No Products Found
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductListingTopPanel from '../topPanel/ProductListingTopPanel'
import ProductListTemplate from './productListTemplate/ProductListTemplate'

export default {
	name: 'product-list-section',
	components: {
		ProductListTemplate,
		ProductListingTopPanel
	},
	props: {
		productList: {
			type: [Array, Object],
			default: () => [] | {}
		},
		showLoader: {
			type: Boolean,
			default: true
		},
		activeCategory: null,
		hideSort: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		...mapGetters('productselected', ['getSelectedProduct']),
		...mapGetters('category', ['getCategoryData']),
		...mapGetters('filters', ['getFilters', 'isFilterApplied', 'getFilterCount']),
		noProductsConditionCheck () {
			return (this.productList && this.productList.length <= 0 && !this.showLoader)
		},
		productsData () {
			let productListData = []
			if (this.productList && this.productList.length > 0) {
				productListData = this.productList.filter(product => product && product.vpi && product.vpi.vendor_id)
			}
			return productListData
		}
	}
}
</script>
